// Accounts — the pure parts, kept out of the page so they can be tested without
// a browser.

/** The categories that actually exist in `public.accounts`, read from live data
 *  (Contractor 8, Real Estate 6, Builder 5, Maintenance Group 2, Strata 2,
 *  Issuer 1, Property Management 1) rather than an invented taxonomy.
 *  Mirrors ACCOUNT_CATEGORIES in @aiw/commands, which refuses anything else on
 *  write — so the filter can never offer a category the data cannot hold. */
export const ACCOUNT_CATEGORIES = [
  "Contractor",
  "Real Estate",
  "Builder",
  "Maintenance Group",
  "Strata",
  "Issuer",
  "Property Management",
] as const;

/** Payment terms as a person says them. An unset term is UNKNOWN — not 0, and
 *  never a default of 30, because a made-up term is a made-up receivable. */
export function termsLabel(days: unknown): string {
  const n = typeof days === "number" && Number.isFinite(days) ? days : null;
  if (n === null) return "terms not set";
  if (n === 0) return "on account · due now";
  return `${n} days`;
}

/** The fields we never show. `domain` is in the table and the owner does not
 *  want it (only 1 of 25 rows has one), and no internal id is ever rendered —
 *  a system-level id is not a reference to put in front of a person. */
export const HIDDEN_ACCOUNT_FIELDS = ["domain", "id"] as const;

/** True when a rendered account row would leak something it must not. Used by
 *  the test as a guard, the same way the document archive guards storage paths. */
export function leaksInternalField(rendered: string): boolean {
  return HIDDEN_ACCOUNT_FIELDS.some((f) => new RegExp(`\\b${f}\\s*[:=]`, "i").test(rendered));
}
